import { heroEquipment } from "../HeroEquipment";

export const dzikieOrki = {
  heroes: {
    "Herszt Dzikich Orków": {
      id: 0,
      startingEquipment: ["Sztylet", "Rembak"],
      cost: 90,
      number: 1,
      equipmentList: heroEquipment["Łowcze plemię Dzikich Orków"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 4, 3, 4, 4, 2, 3, 1, 8],
        Maksymalna: [5, 7, 5, 4, 5, 3, 5, 4, 8],
      },
      rules: [
        "Do Łooomotu!",
        "Dowódca",
        "Furia",
        "Ochronne tatuaże",
        "Zabobonny lęk",
        "Za mną!",
        "Zbrojny po zemby",
      ],
      exp: 20,
      skills: [0, 3, 4, 5],
    },
    "Szaman dzikich orków": {
      id: 1,
      startingEquipment: ["Sztylet", "Kostur"],
      cost: 60,
      number: 1,
      equipmentList: heroEquipment["Łowcze plemię Dzikich Orków"].Bohaterowie,
      type: "Bohater",
      stats: {
        Początkowa: [4, 3, 3, 3, 4, 1, 3, 1, 7],
        Maksymalna: [5, 7, 5, 4, 5, 3, 5, 4, 8],
      },
      rules: ["Furia","Mag (Magia Dużego Łooomotu!)","Ochronne tatuaże","Zabobonny lęk"],
      exp: 10,
      skills: [0, 3, 4, 5],
    },
    "Burszuj dzikich orków": {
      id: 2,
      startingEquipment: [],
      cost: 55,
      number: 2,
      equipmentList: heroEquipment["Łowcze plemię Dzikich Orków"]["Bohaterowie"],
      type: "Bohater",
      stats: {
        Początkowa: [4, 4, 3, 3, 4, 1, 3, 1, 7],
        Maksymalna: [5, 7, 5, 4, 5, 3, 5, 4, 8],
      },
      rules: ["Furia","Ochronne tatuaże","Zabobonny lęk","Zbrojny po zemby"],
      exp: 8,
      skills: [0, 1, 3, 4, 5],
    },
    "Dziki ork": {
      id: 3,
      startingEquipment: ["Sztylet", "Rembak"],
      cost: 40,
      number: 15,
      equipmentList: heroEquipment["Łowcze plemię Dzikich Orków"]["Dziki Ork"],
      type: "Stronnik",
      stats: {
        Początkowa: [4, 3, 3, 3, 4, 1, 2, 1, 7],
        Maksymalna: [5, 7, 5, 4, 5, 3, 5, 4, 8],
      },
      rules: ["Animozja","Chorążowie & sygnaliści","Drużyna ciężkich broni (duża dźgacz)","Furia","Ochronne tatuaże","Zabobonny lęk"],
    },
    "Duże Dźgacze": {
      id: 4,
      startingEquipment: ["Sztylet", "Rembak", "Duża dźgacz"],
      cost: 100,
      number: 2,
      equipmentList: heroEquipment["Łowcze plemię Dzikich Orków"]["Dźgacze"],
      type: "Stronnik",
      stats: {
        Początkowa: [4, 3, 3, 3, 4, 1, 2, 1, 7],
        Maksymalna: [5, 7, 5, 4, 5, 3, 5, 4, 8],
      },
      rules: [
        "Animozja",
        "Duża dźgacz",
        "Furia",
        "Ochronne tautaże",
        "Zabobonny lęk",
      ],
    },
    "Leśny goblin": {
      id: 5,
      startingEquipment: ["Sztylet", "Buława/Maczuga/Młot bojowy"],
      cost: 15,
      number: 15,
      equipmentList:
        heroEquipment["Łowcze plemię Dzikich Orków"]["Leśny Goblin"],
      type: "Stronnik",
      stats: {
        Początkowa: [4, 2, 3, 3, 3, 1, 3, 1, 5],
        Maksymalna: [5, 5, 6, 3, 4, 3, 6, 4, 7],
      },
      rules: ["Animozja","Drużyna obsługi","Dziwnie cuchnom","Nadrzewni drapieżcy","Rozmiar rzondzi","Wspinaczka","Za cienki w uszach"],
    },
    Snotling: {
      id: 6,
      startingEquipment: ["Broń improwizowana", "Wybuchowe zarodniki"],
      cost: 10,
      number: 15,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [4, 2, 0, 2, 2, 1, 3, 1, 4],
        Maksymalna: [4, 2, 0, 2, 2, 1, 3, 1, 4],
      },
      rules: [
        "Mięso armatnie",
        "Rozmiar rzondzi",
        "Nieświadomy",
        "Sfora",
        "Śmigły",
        "Wybuchowe zarodniki",
      ],
    },
    Pajonk: {
      id: 7,
      startingEquipment: ["Broń naturalna (zatruty atak)"],
      cost: 25,
      number: 15,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [7, 3, 0, 3, 3, 1, 4, 1, 2],
        Maksymalna: [7, 3, 0, 3, 3, 1, 4, 1, 2],
      },
      rules: ["Łuskowata skóra (5+)","Murołaz","Niezłomny","Oplątanie","Rozmiar rzondzi","Saper","Zwierzę"],
    },
    "Dziki ork na dziku": {
      id: 8,
      startingEquipment: ["Sztylet", "Rembak", "Dzik", "Siodło & uprząż"],
      cost: 80,
      number: 3,
      equipmentList: heroEquipment["Łowcze plemię Dzikich Orków"]["Dziki Ork"],
      type: "Stronnik",
      stats: {
        Początkowa: [4, 3, 3, 3, 4, 1, 2, 1, 7],
        Maksymalna: [5, 7, 5, 4, 5, 3, 5, 4, 8],
        Dzik: [7, 3, 0, 3, 4, 1, 3, 1, 3],
      },
      rules: ["Animozja","Duży cel (wierzchem)","Furia","Kawalerzysta","Ochronne tatuaże","Zabobonny lęk"],
    },
    Troll: {
      id: 9,
      startingEquipment: ["Broń naturalna"],
      cost: 200,
      number: 1,
      equipmentList: {
        "Troll Górski": [50, 3, "Choice"],
        "Troll Rzeczny": [50, 3, "Choice"],
      },
      type: "Stronnik",
      stats: {
        Początkowa: [6, 3, 1, 5, 4, 3, 1, 3, 4],
        Maksymalna: [6, 3, 1, 5, 4, 3, 1, 3, 4],
      },
      rules: ["Bycza szarża","Duży cel","Gatunki trolli","Głód trzewi","Głupota","Nieświadomy","Niezłomny","Ochronne tatuaże","Przepastne trzewia","Regeneracja","Strach","Wielkolud","Żrąca plwocina"],
    },
    "Wielki Pajonk": {
      id: 10,
      startingEquipment: ["Broń naturalna (zatruty atak)"],
      cost: 180,
      number: 1,
      equipmentList: {},
      type: "Stronnik",
      stats: {
        Początkowa: [7, 3, 0, 4, 4, 3, 4, 3, 7],
        Maksymalna: [7, 3, 0, 4, 4, 3, 4, 3, 7],
      },
      rules: ["Głód trzewi","Łuskowata skóra (4+)","Murołaz","Niezłomny","Omotanie","Oplątanie","Potwór","Wierzchowiec","Zwierzę"],
    },
    Rydwan: {
      id: 11,
      startingEquipment: [],
      cost: 125,
      number: 1,
      equipmentList: {},
      type: "Machina",
      stats: {
        Rydwan: ["-", "-", "-", 5, 5, 8, "-", "-", "-"],
        Dzik: [7, 3, 0, 3, "-", "-", 3, 1, 3],
        "Dzik ": [7, 3, 0, 3, "-", "-", 3, 1, 3],
      },
      rules: ["Duży cel", "Machina wojenna", "Rydwan", "Szarża dzików"],
    },
  },
  limit: 500,
  minModels: 3,
  maxModels: 15,
  name: "Łowcze plemię Dzikich Orków",
  nature: "Zła",
  armyRules: ["Podatek", "Rozrzutność"],
  mercenaries: ["Czarny Ork","Grzybowar","Mekaniak"],
};
